"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSpectraAnalysisPanelsPreferences = exports.deleteAnalysisColumn = exports.changeAnalysisColumnValueKey = exports.analyzeSpectra = void 0;
const MultipleAnalysis = __importStar(require("../../../../data/data1d/multipleSpectraAnalysis"));
const getRange_1 = require("../../helper/getRange");
const panelsPreferencesDefaultValues_1 = require("../panelsPreferencesDefaultValues");
const getActiveWorkspace_1 = require("../utilities/getActiveWorkspace");
function analyzeSpectra(draft, action) {
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    const { start, end, nucleus, columnKey } = action.payload;
    if (!panels.multipleSpectraAnalysis) {
        panels.multipleSpectraAnalysis =
            (0, panelsPreferencesDefaultValues_1.getMultipleSpectraAnalysisDefaultValues)(nucleus);
    }
    const [from, to] = (0, getRange_1.orderRange)(start, end);
    MultipleAnalysis.analyzeSpectra(panels.multipleSpectraAnalysis, {
        from,
        to,
        nucleus,
        columnKey,
    });
}
exports.analyzeSpectra = analyzeSpectra;
function changeAnalysisColumnValueKey(draft, action) {
    const { columnKey, valueKey, nucleus } = action.payload;
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    MultipleAnalysis.changeColumnValueKey(panels.multipleSpectraAnalysis, nucleus, columnKey, valueKey);
}
exports.changeAnalysisColumnValueKey = changeAnalysisColumnValueKey;
function deleteAnalysisColumn(draft, action) {
    const { columnKey, nucleus } = action.payload;
    const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
    const panels = currentWorkspacePreferences.formatting.panels;
    MultipleAnalysis.deleteSpectraAnalysis(panels.multipleSpectraAnalysis, columnKey, nucleus);
}
exports.deleteAnalysisColumn = deleteAnalysisColumn;
function setSpectraAnalysisPanelsPreferences(draft, action) {
    if (action.payload) {
        const currentWorkspacePreferences = (0, getActiveWorkspace_1.getActiveWorkspace)(draft);
        const { nucleus, data } = action.payload;
        const panels = currentWorkspacePreferences.formatting.panels;
        if (!panels?.multipleSpectraAnalysis) {
            panels.multipleSpectraAnalysis =
                (0, panelsPreferencesDefaultValues_1.getMultipleSpectraAnalysisDefaultValues)(nucleus);
        }
        const { analysisOptions, legendsFields } = data;
        panels.multipleSpectraAnalysis[nucleus] = {
            legendsFields,
            analysisOptions: MultipleAnalysis.mapColumns(analysisOptions),
        };
    }
}
exports.setSpectraAnalysisPanelsPreferences = setSpectraAnalysisPanelsPreferences;
